import { proxy } from 'valtio';

export const globalState = proxy({
  i18n: null,
  history: null,
  userInfo: null,
  shopInfo: null
});